import { render, staticRenderFns } from "./BusinessAddresses.vue?vue&type=template&id=58d15aab&"
import script from "./BusinessAddresses.vue?vue&type=script&lang=js&"
export * from "./BusinessAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports